import { render, staticRenderFns } from "./SmsLoginPage.vue?vue&type=template&id=6a3ef74c"
import script from "./SmsLoginPage.vue?vue&type=script&lang=js"
export * from "./SmsLoginPage.vue?vue&type=script&lang=js"
import style0 from "./SmsLoginPage.vue?vue&type=style&index=0&id=6a3ef74c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports